//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../../utils/tmallGenius';
import {findTipsText} from './tipsText'
//
export default {
  components: {},
  data() {
    return {
      deviceName: this.$route.query.deviceName,
      tips: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("语音指令");
    next();
  },
  created() {
    this.selectTips(this.deviceName);
  },
  methods: {
    /*------------------------------------------- 自定义方法 -------------------------------------------------------*/
    /*  设置相应的提示
    * */
    selectTips(deviceName) {
      this.tips = findTipsText(deviceName, this.$route.query.deviceId);
    },
    /*------------------------------------------- 绑定方法 -------------------------------------------------------*/
    /*  点击完成
    * */
    finishClick() {
      this.$router.go(-3);  //回到首页
    },
  }
};



// WEBPACK FOOTER //
// ./src/pages/device/xiaofang/Tips/Index.vue